import React from "react";

const HrraAiChat = () => {
  return <div>HrraAiChat</div>;
};

export default HrraAiChat;
